import React from 'react';
import _ from 'lodash';
import SortByDragListBase from './sortByDragListBase';
import ItemRow from './itemRow';

function onChange1(item, itemIndex, newVal) {
  this.changeItem(itemIndex, newVal);
}

function repeatItem2(item, itemIndex) {
  return /*#__PURE__*/React.createElement(ItemRow, {
    key: 'sbdlItem-' + item.id,
    dynamicHeight: this.props.dynamicHeight,
    dynamicWidth: this.props.dynamicWidth,
    disabled: this.props.disabled || item.disabled,
    draggable: this.isListDraggable(),
    withDragHandle: this.props.draggable,
    isDragging: this.isDragging(itemIndex),
    select: this.props.selectable ? this.selectItem.bind(this, itemIndex) : null,
    isSelected: item.selected,
    value: item,
    labelPlaceholder: this.props.labelPlaceholder,
    valuePlaceholder: this.props.valuePlaceholder,
    labelValidators: this.getLabelValidators(),
    valueValidators: this.getValueValidators(),
    shouldTranslateInvalidLabelMessage: this.props.shouldTranslateInvalidLabelMessage,
    shouldTranslateInvalidValueMessage: this.props.shouldTranslateInvalidValueMessage,
    submitEditLabelButtonText: this.props.submitEditLabelButtonText,
    submitEditValueButtonText: this.props.submitEditValueButtonText,
    className: item.className,
    isContextMenuOpen: item.isContextMenuOpen,
    onContextMenuToggle: item.onContextMenuToggle,
    onChange: onChange1.bind(this, item, itemIndex),
    onHover: this.props.onItemHover,
    menuActions: this.getMenuActions(itemIndex),
    editMode: this.getItemEditMode(itemIndex),
    valuePrefix: this.props.itemValuePrefix,
    labelPrefix: this.props.itemLabelPrefix,
    valueToDisplay: this.props.itemValueToDisplay,
    labelToDisplay: this.props.itemLabelToDisplay,
    automationId: item.automationId,
    dataHook: item.dataHook,
    isDefault: item.isDefault,
    contentBefore: item.contentBefore,
    contentAfter: item.contentAfter,
    customAction: item.customAction,
    removable: item.removable,
    dragHandleEnabled: item.dragHandleEnabled,
    contextMenuAlignment: item.contextMenuAlignment,
    contextMenuDirection: item.contextMenuDirection,
    dynamicItemsGetter: item.dynamicItemsGetter,
    dragHandleTooltipContent: item.dragHandleTooltipContent
  }, item.customActions);
}

export default function () {
  return /*#__PURE__*/React.createElement("div", {
    className: this.getListClasses(),
    "data-aid": this.props.automationId,
    "data-hook": this.props.dataHook,
    style: this.getStyle()
  }, React.createElement.apply(this, [SortByDragListBase, {
    onItemMoved: this.replaceItems,
    draggable: this.isListDraggable(),
    beforeDragStart: this.startDragCallback,
    afterDragEnd: this.endDragCallback,
    dragPlaceholderCssClass: 'sbdl-drag-placeholder'
  }, _.map(this.state.value, repeatItem2.bind(this))]));
}